import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const BrandingContext = createContext();

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({
    logo: "",
    instituteName: "Antigravity Academy",
    headerTitle: "Antigravity LMS",
    footerText: "© 2026 Antigravity Academy. All rights reserved."
  });
  const [loading, setLoading] = useState(true);

  const refreshBranding = async () => {
    try {
      const res = await api.get('/settings/branding');
      if (res.data && Object.keys(res.data).length > 0) {
        // Fallback merge so defaults remain if backend only sent partial fields
        setBranding(prev => ({
          ...prev,
          ...res.data
        }));
      }
    } catch (err) {
      console.error("Branding load failed, using default assets.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshBranding();
  }, []);

  useEffect(() => {
    if (branding.headerTitle) {
      document.title = branding.headerTitle;
    }
  }, [branding.headerTitle]);

  return (
    <BrandingContext.Provider value={{ branding, setBranding, refreshBranding, loading }}>
      {children}
    </BrandingContext.Provider>
  );
}

export const useBranding = () => useContext(BrandingContext);
